"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _battery = require("@/api/iot/battery");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _editDialog = _interopRequireDefault(require("./dialog/editDialog"));
var _trackDialog = _interopRequireDefault(require("./dialog/trackDialog"));
var _detailsDrawer = _interopRequireDefault(require("./dialog/detailsDrawer"));
var _deployDrawer = _interopRequireDefault(require("./dialog/deployDrawer"));
var _batteryType = require("@/api/iot/batteryType");
var _terminalType = require("@/api/iot/terminalType");
var _status = require("@/api/iot/status");
var _default = {
  components: {
    customPage: _customPage.default,
    editDialog: _editDialog.default,
    trackDialog: _trackDialog.default,
    detailsDrawer: _detailsDrawer.default,
    deployDrawer: _deployDrawer.default
  },
  data: function data() {
    return {
      loading: true,
      searchForm: {
        merchant_id: '',
        is_repetition: 0,
        terminal_no: '',
        battery_no: '',
        lock_status: ''
      },
      total: 0,
      tableData: [],
      editItem: null,
      terminalTypeList: [],
      batteryTypeList: [],
      batteryStatusList: [],
      lockStatusList: [],
      merchantList: []
    };
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    // this.getTerminalType()
    this.loadQuery();
    this.getBatteryTypeList();
    this.getBatteryStatusList();
    this.getLockStatusList();
    this.getList();
  },
  methods: {
    loadQuery: function loadQuery() {
      var query = this.$route.query;
      for (var key in this.searchForm) {
        if (query[key]) {
          this.searchForm[key] = query[key];
        }
      }
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getBatteryTypeList: function () {
      var _getBatteryTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _batteryType.batteryTypeList)();
              case 2:
                res = _context2.sent;
                if (res) {
                  this.batteryTypeList = res.data;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getBatteryTypeList() {
        return _getBatteryTypeList.apply(this, arguments);
      }
      return getBatteryTypeList;
    }(),
    getBatteryStatusList: function () {
      var _getBatteryStatusList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _status.getBatteryStatusList)();
              case 2:
                res = _context3.sent;
                if (res) {
                  this.batteryStatusList = res;
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getBatteryStatusList() {
        return _getBatteryStatusList2.apply(this, arguments);
      }
      return getBatteryStatusList;
    }(),
    getLockStatusList: function () {
      var _getLockStatusList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _status.getLockStatusList)();
              case 2:
                res = _context4.sent;
                if (res) {
                  this.lockStatusList = res;
                }
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function getLockStatusList() {
        return _getLockStatusList2.apply(this, arguments);
      }
      return getLockStatusList;
    }(),
    getList: function getList(flag) {
      var _this = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _battery.batteryList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this.loading = false;
        _this.tableData = res.data || [];
        _this.total = res.total;
      });
    },
    // 检测健康状态
    chkHealthStatusType: function chkHealthStatusType(status) {
      var type = 'success';
      if (status == 0) {
        type = 'warning';
      }
      return type;
    },
    // 检测锁定状态
    chkLockStatusType: function chkLockStatusType(status) {
      var type = 'success';
      if (status == 1) {
        type = 'danger';
      }
      return type;
    },
    // 检测租借状态
    chkBatteryStatusType: function chkBatteryStatusType(status) {
      var type = 'info';
      if (status == 1) {
        type = 'primary';
      } else if (status == 3) {
        type = 'success';
      } else if (status == 4) {
        type = 'danger';
      }
      return type;
    },
    // 编辑
    openEditDialog: function openEditDialog(val) {
      this.editItem = val || null;
      this.$refs.editDialog.dialogVisible = true;
    },
    // 电池轨迹
    openTrackDialog: function openTrackDialog(val) {
      this.editItem = val || null;
      this.$refs.trackDialog.dialogVisible = true;
    },
    // 配置
    openDeployDrawer: function openDeployDrawer(val) {
      this.editItem = val || null;
      this.$refs.deployDrawer.dialogVisible = true;
    },
    // 详情
    openDetailsDrawer: function openDetailsDrawer(val) {
      this.editItem = val || null;
      this.$refs.detailsDrawer.dialogVisible = true;
    },
    // 删除
    removeItem: function removeItem(item) {
      var _this2 = this;
      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _battery.batteryDel)({
          id: item.id
        }).then(function (res) {
          _this2.getList(true);
        });
      }).catch(function () {});
    },
    // 刷新
    refresh: function refresh(item) {
      this.$confirm('您确定要执行 刷新 操作吗?', '刷新', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 开门
    openDoor: function openDoor(item) {
      this.$confirm('您确定要执行 开门 操作吗?', '开门', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 补电
    charge: function charge(item) {
      this.$confirm('您确定要执行 补电 操作吗?', '补电', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 同步bms数据
    syncBms: function syncBms(item) {
      this.$func.isSuccess('同步bms数据');
    },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 跳转到电池仓
    jumpBatteryBunker: function jumpBatteryBunker() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$h5.href({
        name: 'chkgBatteryBunker',
        query: {
          terminal_no: item.terminal_no
        }
      }, 1);
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    },
    getTerminalType: function getTerminalType() {
      var _this3 = this;
      (0, _terminalType.terminalTypeList)().then(function (res) {
        _this3.terminalTypeList = res;
      });
    }
  }
};
exports.default = _default;